import { PageLocatorMap } from '../types/PageLocatorMap';

export const applicantPreviousResidencePage = {
  alert: {
    error: 'applicant-previous-residence-page.alert.error',
  },
  footer: {
    root: 'applicant-previous-residence-page.footer.root',
  },
  form: {
    addressLine1Input:
      'applicant-previous-residence-page.form.address-line-1-input',
    addressLine1InputError:
      'applicant-previous-residence-page.form.address-line-1-input-error',
    addressLine2Input:
      'applicant-previous-residence-page.form.address-line-2-input',
    cityInput: 'applicant-previous-residence-page.form.city-input',
    cityInputError: 'applicant-previous-residence-page.form.city-input-error',
    h1: 'applicant-previous-residence-page.form.h1',
    h2: 'applicant-previous-residence-page.form.h2',
    root: 'applicant-previous-residence-page.form.root',
    stateSelect: 'applicant-previous-residence-page.form.state-select',
    stateSelectError:
      'applicant-previous-residence-page.form.state-select-error',
    submitButton: 'applicant-previous-residence-page.form.submit-button',
    zipCodeInput: 'applicant-previous-residence-page.form.zip-code-input',
    zipCodeInputError:
      'applicant-previous-residence-page.form.zip-code-input-error',
  },
  header: {
    drawerButton: 'applicant-previous-residence-page.header.drawer-button',
    previousStepButton:
      'applicant-previous-residence-page.header.previous-step-button',
    root: 'applicant-previous-residence-page.header.root',
  },
  progress: {
    root: 'applicant-previous-residence-page.progress.root',
  },
} as const satisfies PageLocatorMap;
